export const test_values = {
  perm_to_disclose: 'Confidential',
  anonymous_acknowledgement: ['No'],
  complainant_first_name: 'Tom',
  complainant_middle_name: 'J',
  complainant_last_name: 'Smith',
  complainant_suffix: 'JR',
  complainant_home_phone: '123-456-7890',
  complainant_cell_phone: '929-333-4444',
  complainant_work_phone: '703-454-2323',
  complainant_personal_email: 'tom@example.com',
  complainant_address: {
    line1Value: '123 Main St',
    line2Value: '#100',
    cityValue: 'Anytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  complainant_job_title: 'CEO',
  subject_type_0: 'Individual',
  subj_first_name_0: 'Bill',
  subj_middle_name_0: 'B',
  subj_last_name_0: 'Brown',
  subj_suffix_0: 'SR',
  subj_employer_phone_0: '345-678-9010',
  subj_work_phone_0: '234-567-8901',
  subj_personal_email_0: 'bill@example.com',
  subj_job_title_0: 'CEO',
  subj_alias_nickname_0: 'Im Smart',
  subj_relationship_0: 'Other',
  subj_relationship_other_0: 'Supervisor',
  subj_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  subj_employer_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  witness_first_name_0: 'Adam',
  witness_middle_name_0: 'E',
  witness_last_name_0: 'Smith',
  witness_suffix_0: 'JR',
  witness_alias_nickname_0: 'Ima Goodguy',
  witness_dob_0: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1998'
  },
  witness_email_0: 'b@b.com',
  witness_home_phone_0: '123-123-1234',
  witness_cell_phone_0: '234-234-2345',
  witness_address_0: {
    line1Value: '123 My Street',
    line2Value: 'Apt 507',
    cityValue: 'Mytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  witness_employer_0: 'Acme, Inc.',
  witness_job_title_0: 'Financial Analyst',
  witness_employer_address_0: {
    line1Value: '123 My Way',
    line2Value: 'Suite 500',
    cityValue: 'Menlo Park',
    stateValue: 'CA',
    zipValue: '91222',
    countryValue: 'US'
  },
  witness_work_email_0: 'asmith@acme.com',
  witness_employer_phone_0: '121-232-3443',
  witness_work_phone_0: '232-343-4554',
  date_of_activity: { dayValue: '22', monthValue: '02', yearValue: '2000' },
  activity_end_date: { dayValue: '27', monthValue: '02', yearValue: '2000' },
  disclosure_date: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '2000'
  },
  disclosure_type: ['Fraud', 'Waste'],
  non_anon_perm_to_disclose: 'Confidential',
  complainant_employer: 'Federal Employee',
  complainant_work_email: 'tom.smith@oig.hhs.gov',
  work_place: 'Loading Dock',
  complainant_work_address: {
    line1Value: '444 Fake St',
    line2Value: 'Suite 34',
    cityValue: 'Vancouver',
    stateValue: 'BC',
    zipValue: '11111',
    countryValue: 'CA'
  },
  employer_other: '',
  narrative: 'Narrative goes here.',
  communication_contact: ['Management', 'HHS-OIG'],
  communication_contact_other: '',
  protected_communication_warning: 'No',
  protected_disclosure_warning: 'No',
  retaliation_action: ['Discipline', 'Suspension'],
  retaliation_action_other: '',
  retaliation_reason: 'Discrimination',
  still_happening: 'Yes'
}

export const non_disclosure_test_values = {
  perm_to_disclose: 'Anonymous',
  complainant_first_name: '',
  complainant_middle_name: '',
  complainant_last_name: '',
  complainant_suffix: '',
  complainant_home_phone: '',
  complainant_cell_phone: '',
  complainant_work_phone: '',
  complainant_email: '',
  complainant_address: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  subj_1_first_name: 'Bill',
  subj_1_middle_name: 'B',
  subj_1_last_name: 'Brown',
  subj_1_suffix: 'SR',
  subj_1_phone_home: '345-678-9010',
  subj_1_email_personal: 'bill@example.com',
  complainant_job_title: 'CEO',
  action_begin_date: { dayValue: '22', monthValue: '02', yearValue: '2000' },
  action_end_date: { dayValue: '27', monthValue: '02', yearValue: '2000' },
  disclosure_date: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '2000'
  },
  disclosure_type: ['Fraud', 'Waste'],
  complainant_employer: 'Federal Employee',
  complainant_work_email: 'tom.smith@oig.hhs.gov',
  work_place: 'Loading Dock',
  complainant_work_address: {
    line1Value: '444 Fake St',
    line2Value: 'Suite 34',
    cityValue: 'Vancouver',
    stateValue: 'BC',
    zipValue: '11111',
    countryValue: 'CA'
  },
  employer_other: '',
  narrative: 'Narrative goes here.',
  communication_contact: ['Management', 'HHS-OIG'],
  communication_contact_other: '',
  retaliation_action: ['Discipline', 'Suspension'],
  retaliation_action_other: '',
  retaliation_reason: 'Discrimination',
  still_happening: 'Yes'
}

export const test_values_aip = {
  complainant_first_name: 'Tom',
  complainant_middle_name: 'J',
  complainant_last_name: 'Smith',
  complainant_suffix: 'JR',
  complainant_home_phone: '123-456-7890',
  complainant_cell_phone: '929-333-4444',
  complainant_work_phone: '703-454-2323',
  complainant_personal_email: 'tom@example.com',
  complainant_address: {
    line1Value: '123 Main St',
    line2Value: '#100',
    cityValue: 'Anytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  complainant_dob: { dayValue: '13', monthValue: '03', yearValue: '1977' },
  complainant_medicare_number: 'ABCD-123-2334',
  complainant_medicaid_number: '01a5fg02hj993gy',
  complainant_ssn: '222-22-2222',
  subject_type_0: 'Individual',
  subj_first_name_0: 'Bill',
  subj_middle_name_0: 'B',
  subj_last_name_0: 'Brown',
  subj_suffix_0: 'SR',
  subj_employer_phone_0: '345-678-9010',
  subj_work_phone_0: '234-567-8901',
  subj_personal_email_0: 'bill@example.com',
  subj_job_title_0: 'CEO',
  subj_alias_nickname_0: 'Im Smart',
  subj_relationship_0: 'Other',
  subj_relationship_other_0: 'Supervisor',
  subj_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  subj_employer_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  date_of_activity: { dayValue: '22', monthValue: '02', yearValue: '2000' },
  activity_end_date: { dayValue: '27', monthValue: '02', yearValue: '2000' },
  previously_reported_date: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '2000'
  },
  perm_to_disclose: 'Confidential',
  complainant_employer: 'ABC, Inc.',
  complainant_work_email: 'tom.smith@abc.com',
  complainant_work_address: {
    line1Value: '444 Fake St',
    line2Value: 'Suite 34',
    cityValue: 'Las Vegas',
    stateValue: 'NV',
    zipValue: '11111',
    countryValue: 'US'
  },
  complainant_employer_phone: '123-123-4567',
  complainant_hhs_employee: 'Yes',
  narrative: 'Narrative goes here.',
  communication_contact: 'Management',
  communication_contact_other: '',
  witness_first_name_0: 'Adam',
  witness_middle_name_0: 'E',
  witness_last_name_0: 'Smith',
  witness_suffix_0: 'JR',
  witness_alias_nickname_0: 'Ima Goodguy',
  witness_dob_0: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1998'
  },
  witness_email_0: 'b@b.com',
  witness_home_phone_0: '123-123-1234',
  witness_cell_phone_0: '234-234-2345',
  witness_address_0: {
    line1Value: '123 My Street',
    line2Value: 'Apt 507',
    cityValue: 'Mytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  witness_employer_0: 'Acme, Inc.',
  witness_job_title_0: 'Financial Analyst',
  witness_employer_address_0: {
    line1Value: '123 My Way',
    line2Value: 'Suite 500',
    cityValue: 'Menlo Park',
    stateValue: 'CA',
    zipValue: '91222',
    countryValue: 'US'
  },
  witness_work_email_0: 'asmith@acme.com',
  witness_employer_phone_0: '121-232-3443',
  witness_work_phone_0: '232-343-4554'
}

export const test_values_fcs = {
  owe_more_than_minimum_yn: 'Yes',
  amount_owed: '$10,000.05',
  subject_in_different_location_yn: 'Yes',
  subject_location: 'Nevada',
  court_order_exists_yn: 'Yes',
  court_name: 'US District Court of Families Northern Utah',
  case_number: '2018D123456',
  court_order_date: { dayValue: '02', monthValue: '02', yearValue: '2010' },
  case_worker_assigned_yn: 'Yes',
  case_worker_first_name: 'Kevin',
  case_worker_last_name: 'Long',
  case_worker_phone: '111-222-3333',
  case_worker_email: 'kevin@long.com',
  child_is_minor_yn: 'Yes',
  hhs_program: '',
  hhs_program_other: '',
  complainant_first_name: 'Tom',
  complainant_middle_name: 'J',
  complainant_last_name: 'Smith',
  complainant_suffix: 'JR',
  complainant_home_phone: '123-456-7890',
  complainant_cell_phone: '929-333-4444',
  complainant_work_phone: '703-454-2323',
  complainant_personal_email: 'tom@example.com',
  complainant_address: {
    line1Value: '123 Main St',
    line2Value: '#100',
    cityValue: 'Anytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  complainant_dob: { dayValue: '13', monthValue: '03', yearValue: '1977' },
  complainant_medicare_number: 'ABCD-123-2334',
  complainant_medicaid_number: '01a5fg02hj993gy',
  complainant_ssn: '222-22-2222',
  subject_type_0: 'Individual',
  subj_first_name_0: 'Bill',
  subj_middle_name_0: 'B',
  subj_last_name_0: 'Brown',
  subj_suffix_0: 'SR',
  subj_employer_phone_0: '345-678-9010',
  subj_work_phone_0: '234-567-8901',
  subj_personal_email_0: 'bill@example.com',
  subj_job_title_0: 'CEO',
  subj_alias_nickname_0: 'Im Smart',
  subj_relationship_0: 'Other',
  subj_relationship_other_0: 'Supervisor',
  subj_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  subj_employer_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  date_of_activity: { dayValue: '22', monthValue: '02', yearValue: '2000' },
  activity_end_date: { dayValue: '27', monthValue: '02', yearValue: '2000' },
  previously_reported_date: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '2000'
  },
  perm_to_disclose: 'Confidential',
  complainant_employer: 'ABC, Inc.',
  complainant_work_email: 'tom.smith@abc.com',
  complainant_work_address: {
    line1Value: '444 Fake St',
    line2Value: 'Suite 34',
    cityValue: 'Las Vegas',
    stateValue: 'NV',
    zipValue: '11111',
    countryValue: 'US'
  },
  complainant_employer_phone: '123-123-4567',
  complainant_hhs_employee: 'Yes',
  narrative: 'Narrative goes here.',
  communication_contact: 'Management',
  communication_contact_other: '',
  witness_first_name_0: 'Adam',
  witness_middle_name_0: 'E',
  witness_last_name_0: 'Smith',
  witness_suffix_0: 'JR',
  witness_alias_nickname_0: 'Ima Goodguy',
  witness_dob_0: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1998'
  },
  witness_email_0: 'b@b.com',
  witness_home_phone_0: '123-123-1234',
  witness_cell_phone_0: '234-234-2345',
  witness_address_0: {
    line1Value: '123 My Street',
    line2Value: 'Apt 507',
    cityValue: 'Mytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  witness_employer_0: 'Acme, Inc.',
  witness_job_title_0: 'Financial Analyst',
  witness_employer_address_0: {
    line1Value: '123 My Way',
    line2Value: 'Suite 500',
    cityValue: 'Menlo Park',
    stateValue: 'CA',
    zipValue: '91222',
    countryValue: 'US'
  },
  witness_work_email_0: 'asmith@acme.com',
  witness_employer_phone_0: '121-232-3443',
  witness_work_phone_0: '232-343-4554'
}

export const test_values_hcf = {
  allegation: 'kickbacks',
  hhs_program: 'medicaid',
  hhs_program_type: 'home',
  complainant_first_name: 'Tom',
  complainant_middle_name: 'J',
  complainant_last_name: 'Smith',
  complainant_suffix: 'JR',
  complainant_home_phone: '123-456-7890',
  complainant_cell_phone: '929-333-4444',
  complainant_work_phone: '703-454-2323',
  complainant_personal_email: 'tom@example.com',
  complainant_address: {
    line1Value: '123 Main St',
    line2Value: '#100',
    cityValue: 'Anytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  complainant_dob: { dayValue: '13', monthValue: '03', yearValue: '1977' },
  complainant_medicare_number: 'ABCD-123-2334',
  complainant_medicaid_number: '01a5fg02hj993gy',
  complainant_ssn: '222-22-2222',
  subject_type_0: 'Individual',
  subj_first_name_0: 'Bill',
  subj_middle_name_0: 'B',
  subj_last_name_0: 'Brown',
  subj_suffix_0: 'SR',
  subj_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  subj_employer_phone_0: '345-678-9010',
  subj_work_phone_0: '234-567-8901',
  subj_personal_email_0: 'bill@example.com',
  subj_job_title_0: 'CEO',
  subj_alias_nickname_0: 'Im Smart',
  subj_relationship_0: 'Other',
  subj_relationship_other_0: 'Supervisor',
  subj_employer_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  date_of_activity: { dayValue: '22', monthValue: '02', yearValue: '2000' },
  activity_end_date: { dayValue: '27', monthValue: '02', yearValue: '2000' },
  previously_reported_date: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '2000'
  },
  perm_to_disclose: 'Confidential',
  complainant_employer: 'ABC, Inc.',
  complainant_work_email: 'tom.smith@abc.com',
  complainant_work_address: {
    line1Value: '444 Fake St',
    line2Value: 'Suite 34',
    cityValue: 'Las Vegas',
    stateValue: 'NV',
    zipValue: '11111',
    countryValue: 'US'
  },
  complainant_employer_phone: '123-123-4567',
  complainant_hhs_employee: 'Yes',
  narrative: 'Narrative goes here.',
  communication_contact: 'Management',
  communication_contact_other: '',
  witness_first_name_0: 'Adam',
  witness_middle_name_0: 'E',
  witness_last_name_0: 'Smith',
  witness_suffix_0: 'JR',
  witness_alias_nickname_0: 'Ima Goodguy',
  witness_dob_0: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1998'
  },
  witness_email_0: 'b@b.com',
  witness_home_phone_0: '123-123-1234',
  witness_cell_phone_0: '234-234-2345',
  witness_address_0: {
    line1Value: '123 My Street',
    line2Value: 'Apt 507',
    cityValue: 'Mytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  witness_employer_0: 'Acme, Inc.',
  witness_job_title_0: 'Financial Analyst',
  witness_employer_address_0: {
    line1Value: '123 My Way',
    line2Value: 'Suite 500',
    cityValue: 'Menlo Park',
    stateValue: 'CA',
    zipValue: '91222',
    countryValue: 'US'
  },
  witness_work_email_0: 'asmith@acme.com',
  witness_employer_phone_0: '121-232-3443',
  witness_work_phone_0: '232-343-4554',
  victim_first_name: 'Robert',
  victim_middle_name: 'E',
  victim_last_name: 'Wilcox',
  victim_suffix: 'JR',
  victim_alias_nickname: 'Bob',
  victim_address: {
    line1Value: '232 Cherry Tree Ln',
    line2Value: '',
    cityValue: 'Springfield',
    stateValue: 'VA',
    zipValue: '22333',
    countryValue: 'US'
  },
  victim_dob: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1978'
  },
  victim_ssn: '223-23-2233',
  victim_medicare_number: 'ABCD-343-2334',
  victim_medicaid_number: '01a5fg02hj993gy',
  victim_email: 'b@b.com',
  victim_personal_phone: '234-234-2334',
  victim_alternative_phone: '345-345-3445'
}

export const test_values_fwa = {
  allegation: 'crime',
  allegation_other: '',
  employee_type: 'HHS Contractor',
  employee_type_other: '',
  hhs_program: 'asa',
  hhs_program_other: '',
  retaliated_against: 'Yes',
  complainant_first_name: 'Tom',
  complainant_middle_name: 'J',
  complainant_last_name: 'Smith',
  complainant_suffix: 'JR',
  complainant_home_phone: '123-456-7890',
  complainant_cell_phone: '929-333-4444',
  complainant_work_phone: '703-454-2323',
  complainant_personal_email: 'tom@example.com',
  complainant_address: {
    line1Value: '123 Main St',
    line2Value: '#100',
    cityValue: 'Anytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  complainant_dob: { dayValue: '13', monthValue: '03', yearValue: '1977' },
  complainant_medicare_number: 'ABCD-123-2334',
  complainant_medicaid_number: '01a5fg02hj993gy',
  complainant_ssn: '222-22-2222',
  subject_type_0: 'Individual',
  subj_first_name_0: 'Bill',
  subj_middle_name_0: 'B',
  subj_last_name_0: 'Brown',
  subj_suffix_0: 'SR',
  subj_employer_phone_0: '345-678-9010',
  subj_work_phone_0: '234-567-8901',
  subj_personal_email_0: 'bill@example.com',
  subj_job_title_0: 'CEO',
  subj_alias_nickname_0: 'Im Smart',
  subj_relationship_0: 'Other',
  subj_relationship_other_0: 'Supervisor',
  subj_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  subj_employer_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  date_of_activity: { dayValue: '22', monthValue: '02', yearValue: '2000' },
  activity_end_date: { dayValue: '27', monthValue: '02', yearValue: '2000' },
  previously_reported_date: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '2000'
  },
  perm_to_disclose: 'Confidential',
  complainant_employer: 'ABC, Inc.',
  complainant_work_email: 'tom.smith@abc.com',
  complainant_work_address: {
    line1Value: '444 Fake St',
    line2Value: 'Suite 34',
    cityValue: 'Las Vegas',
    stateValue: 'NV',
    zipValue: '11111',
    countryValue: 'US'
  },
  complainant_employer_phone: '123-123-4567',
  complainant_hhs_employee: 'Yes',
  narrative: 'Narrative goes here.',
  communication_contact: 'Management',
  communication_contact_other: '',
  witness_first_name_0: 'Adam',
  witness_middle_name_0: 'E',
  witness_last_name_0: 'Smith',
  witness_suffix_0: 'JR',
  witness_alias_nickname_0: 'Ima Goodguy',
  witness_dob_0: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1998'
  },
  witness_email_0: 'b@b.com',
  witness_home_phone_0: '123-123-1234',
  witness_cell_phone_0: '234-234-2345',
  witness_address_0: {
    line1Value: '123 My Street',
    line2Value: 'Apt 507',
    cityValue: 'Mytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  witness_employer_0: 'Acme, Inc.',
  witness_job_title_0: 'Financial Analyst',
  witness_employer_address_0: {
    line1Value: '123 My Way',
    line2Value: 'Suite 500',
    cityValue: 'Menlo Park',
    stateValue: 'CA',
    zipValue: '91222',
    countryValue: 'US'
  },
  witness_work_email_0: 'asmith@acme.com',
  witness_employer_phone_0: '121-232-3443',
  witness_work_phone_0: '232-343-4554'
}

export const test_values_gcf = {
  allegation: 'kickbacks',
  allegation_other: '',
  award_type_0: 'Contract',
  award_number_0: 'RCF-0123',
  executive_director_0: 'Sam Champion',
  award_type_1: 'Grant',
  award_number_1: '2020-ABC-123',
  executive_director_1: 'Francis Drake',
  hhs_program: 'acf',
  hhs_program_other: '',
  complainant_first_name: 'Tom',
  complainant_middle_name: 'J',
  complainant_last_name: 'Smith',
  complainant_suffix: 'JR',
  complainant_home_phone: '123-456-7890',
  complainant_cell_phone: '929-333-4444',
  complainant_work_phone: '703-454-2323',
  complainant_personal_email: 'tom@example.com',
  complainant_address: {
    line1Value: '123 Main St',
    line2Value: '#100',
    cityValue: 'Anytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  complainant_dob: { dayValue: '13', monthValue: '03', yearValue: '1977' },
  complainant_medicare_number: 'ABCD-123-2334',
  complainant_medicaid_number: '01a5fg02hj993gy',
  complainant_ssn: '222-22-2222',
  subject_type_0: 'Individual',
  subj_first_name_0: 'Bill',
  subj_middle_name_0: 'B',
  subj_last_name_0: 'Brown',
  subj_suffix_0: 'SR',
  subj_employer_phone_0: '345-678-9010',
  subj_work_phone_0: '234-567-8901',
  subj_personal_email_0: 'bill@example.com',
  subj_job_title_0: 'CEO',
  subj_alias_nickname_0: 'Im Smart',
  subj_relationship_0: 'Other',
  subj_relationship_other_0: 'Supervisor',
  subj_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  subj_employer_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  date_of_activity: { dayValue: '22', monthValue: '02', yearValue: '2000' },
  activity_end_date: { dayValue: '27', monthValue: '02', yearValue: '2000' },
  previously_reported_date: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '2000'
  },
  perm_to_disclose: 'Confidential',
  complainant_employer: 'ABC, Inc.',
  complainant_work_email: 'tom.smith@abc.com',
  complainant_work_address: {
    line1Value: '444 Fake St',
    line2Value: 'Suite 34',
    cityValue: 'Las Vegas',
    stateValue: 'NV',
    zipValue: '11111',
    countryValue: 'US'
  },
  complainant_employer_phone: '123-123-4567',
  complainant_hhs_employee: 'Yes',
  narrative: 'Narrative goes here.',
  communication_contact: 'Management',
  communication_contact_other: '',
  witness_first_name_0: 'Adam',
  witness_middle_name_0: 'E',
  witness_last_name_0: 'Smith',
  witness_suffix_0: 'JR',
  witness_alias_nickname_0: 'Ima Goodguy',
  witness_dob_0: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1998'
  },
  witness_email_0: 'b@b.com',
  witness_home_phone_0: '123-123-1234',
  witness_cell_phone_0: '234-234-2345',
  witness_address_0: {
    line1Value: '123 My Street',
    line2Value: 'Apt 507',
    cityValue: 'Mytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  witness_employer_0: 'Acme, Inc.',
  witness_job_title_0: 'Financial Analyst',
  witness_employer_address_0: {
    line1Value: '123 My Way',
    line2Value: 'Suite 500',
    cityValue: 'Menlo Park',
    stateValue: 'CA',
    zipValue: '91222',
    countryValue: 'US'
  },
  witness_work_email_0: 'asmith@acme.com',
  witness_employer_phone_0: '121-232-3443',
  witness_work_phone_0: '232-343-4554'
}

export const test_values_mit = {
  complainant_first_name: 'Tom',
  complainant_middle_name: 'J',
  complainant_last_name: 'Smith',
  complainant_suffix: 'JR',
  complainant_home_phone: '123-456-7890',
  complainant_cell_phone: '929-333-4444',
  complainant_work_phone: '703-454-2323',
  complainant_personal_email: 'tom@example.com',
  complainant_address: {
    line1Value: '123 Main St',
    line2Value: '#100',
    cityValue: 'Anytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  complainant_dob: { dayValue: '13', monthValue: '03', yearValue: '1977' },
  complainant_medicare_number: 'ABCD-123-2334',
  complainant_medicaid_number: '01a5fg02hj993gy',
  complainant_ssn: '222-22-2222',
  subject_type_0: 'Individual',
  subj_first_name_0: 'Bill',
  subj_middle_name_0: 'B',
  subj_last_name_0: 'Brown',
  subj_suffix_0: 'SR',
  subj_employer_phone_0: '345-678-9010',
  subj_work_phone_0: '234-567-8901',
  subj_personal_email_0: 'bill@example.com',
  subj_job_title_0: 'CEO',
  subj_alias_nickname_0: 'Im Smart',
  subj_relationship_0: 'Other',
  subj_relationship_other_0: 'Supervisor',
  subj_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  subj_employer_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  date_of_activity: { dayValue: '22', monthValue: '02', yearValue: '2000' },
  activity_end_date: { dayValue: '27', monthValue: '02', yearValue: '2000' },
  previously_reported_date: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '2000'
  },
  perm_to_disclose: 'Confidential',
  complainant_employer: 'ABC, Inc.',
  complainant_work_email: 'tom.smith@abc.com',
  complainant_work_address: {
    line1Value: '444 Fake St',
    line2Value: 'Suite 34',
    cityValue: 'Las Vegas',
    stateValue: 'NV',
    zipValue: '11111',
    countryValue: 'US'
  },
  complainant_employer_phone: '123-123-4567',
  complainant_hhs_employee: 'Yes',
  narrative: 'Narrative goes here.',
  communication_contact: 'Management',
  communication_contact_other: '',
  witness_first_name_0: 'Adam',
  witness_middle_name_0: 'E',
  witness_last_name_0: 'Smith',
  witness_suffix_0: 'JR',
  witness_alias_nickname_0: 'Ima Goodguy',
  witness_dob_0: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1998'
  },
  witness_email_0: 'b@b.com',
  witness_home_phone_0: '123-123-1234',
  witness_cell_phone_0: '234-234-2345',
  witness_address_0: {
    line1Value: '123 My Street',
    line2Value: 'Apt 507',
    cityValue: 'Mytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  witness_employer_0: 'Acme, Inc.',
  witness_job_title_0: 'Financial Analyst',
  witness_employer_address_0: {
    line1Value: '123 My Way',
    line2Value: 'Suite 500',
    cityValue: 'Menlo Park',
    stateValue: 'CA',
    zipValue: '91222',
    countryValue: 'US'
  },
  witness_work_email_0: 'asmith@acme.com',
  witness_employer_phone_0: '121-232-3443',
  witness_work_phone_0: '232-343-4554',
  victim_first_name: 'Robert',
  victim_middle_name: 'E',
  victim_last_name: 'Wilcox',
  victim_suffix: 'JR',
  victim_alias_nickname: 'Bob',
  victim_address: {
    line1Value: '232 Cherry Tree Ln',
    line2Value: '',
    cityValue: 'Springfield',
    stateValue: 'VA',
    zipValue: '22333',
    countryValue: 'US'
  },
  victim_dob: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1978'
  },
  victim_ssn: '223-23-2233',
  victim_medicare_number: 'ABCD-123-2334',
  victim_medicaid_number: '01a5fg02hj993gy',
  victim_email: 'b@b.com',
  victim_personal_phone: '234-234-2334',
  victim_alternative_phone: '345-345-3445'
}

export const test_values_other = {
  hhs_program: 'acf',
  hhs_program_other: '',
  complainant_first_name: 'Tom',
  complainant_middle_name: 'J',
  complainant_last_name: 'Smith',
  complainant_suffix: 'JR',
  complainant_home_phone: '123-456-7890',
  complainant_cell_phone: '929-333-4444',
  complainant_work_phone: '703-454-2323',
  complainant_personal_email: 'tom@example.com',
  complainant_address: {
    line1Value: '123 Main St',
    line2Value: '#100',
    cityValue: 'Anytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  complainant_dob: { dayValue: '13', monthValue: '03', yearValue: '1977' },
  complainant_medicare_number: 'ABCD-123-2334',
  complainant_medicaid_number: '01a5fg02hj993gy',
  complainant_ssn: '222-22-2222',
  subject_type_0: 'Individual',
  subj_first_name_0: 'Bill',
  subj_middle_name_0: 'B',
  subj_last_name_0: 'Brown',
  subj_suffix_0: 'SR',
  subj_employer_phone_0: '345-678-9010',
  subj_work_phone_0: '234-567-8901',
  subj_personal_email_0: 'bill@example.com',
  subj_job_title_0: 'CEO',
  subj_alias_nickname_0: 'Im Smart',
  subj_relationship_0: 'Other',
  subj_relationship_other_0: 'Supervisor',
  subj_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  subj_employer_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  date_of_activity: { dayValue: '22', monthValue: '02', yearValue: '2000' },
  activity_end_date: { dayValue: '27', monthValue: '02', yearValue: '2000' },
  previously_reported_date: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '2000'
  },
  perm_to_disclose: 'Confidential',
  complainant_employer: 'ABC, Inc.',
  complainant_work_email: 'tom.smith@abc.com',
  complainant_work_address: {
    line1Value: '444 Fake St',
    line2Value: 'Suite 34',
    cityValue: 'Las Vegas',
    stateValue: 'NV',
    zipValue: '11111',
    countryValue: 'US'
  },
  complainant_employer_phone: '123-123-4567',
  complainant_hhs_employee: 'Yes',
  narrative: 'Narrative goes here.',
  communication_contact: 'Management',
  communication_contact_other: '',
  witness_first_name_0: 'Adam',
  witness_middle_name_0: 'E',
  witness_last_name_0: 'Smith',
  witness_suffix_0: 'JR',
  witness_alias_nickname_0: 'Ima Goodguy',
  witness_dob_0: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1998'
  },
  witness_email_0: 'b@b.com',
  witness_home_phone_0: '123-123-1234',
  witness_cell_phone_0: '234-234-2345',
  witness_address_0: {
    line1Value: '123 My Street',
    line2Value: 'Apt 507',
    cityValue: 'Mytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  witness_employer_0: 'Acme, Inc.',
  witness_job_title_0: 'Financial Analyst',
  witness_employer_address_0: {
    line1Value: '123 My Way',
    line2Value: 'Suite 500',
    cityValue: 'Menlo Park',
    stateValue: 'CA',
    zipValue: '91222',
    countryValue: 'US'
  },
  witness_work_email_0: 'asmith@acme.com',
  witness_employer_phone_0: '121-232-3443',
  witness_work_phone_0: '232-343-4554'
}

export const test_values_qoc = {
  complainant_first_name: 'Tom',
  complainant_middle_name: 'J',
  complainant_last_name: 'Smith',
  complainant_suffix: 'JR',
  complainant_home_phone: '123-456-7890',
  complainant_cell_phone: '929-333-4444',
  complainant_work_phone: '703-454-2323',
  complainant_personal_email: 'tom@example.com',
  complainant_address: {
    line1Value: '123 Main St',
    line2Value: '#100',
    cityValue: 'Anytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  complainant_dob: { dayValue: '13', monthValue: '03', yearValue: '1977' },
  complainant_medicare_number: 'ABCD-123-2334',
  complainant_medicaid_number: '01a5fg02hj993gy',
  complainant_ssn: '222-22-2222',
  subject_type_0: 'Individual',
  subj_first_name_0: 'Bill',
  subj_middle_name_0: 'B',
  subj_last_name_0: 'Brown',
  subj_suffix_0: 'SR',
  subj_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  subj_employer_phone_0: '345-678-9010',
  subj_work_phone_0: '234-567-8901',
  subj_personal_email_0: 'bill@example.com',
  subj_job_title_0: 'CEO',
  subj_alias_nickname_0: 'Im Smart',
  subj_relationship_0: 'Other',
  subj_relationship_other_0: 'Supervisor',
  subj_employer_address_0: {
    line1Value: '',
    line2Value: '',
    cityValue: '',
    stateValue: '',
    zipValue: '',
    countryValue: ''
  },
  date_of_activity: { dayValue: '22', monthValue: '02', yearValue: '2000' },
  activity_end_date: { dayValue: '27', monthValue: '02', yearValue: '2000' },
  previously_reported_date: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '2000'
  },
  perm_to_disclose: 'Confidential',
  complainant_employer: 'ABC, Inc.',
  complainant_work_email: 'tom.smith@abc.com',
  complainant_work_address: {
    line1Value: '444 Fake St',
    line2Value: 'Suite 34',
    cityValue: 'Las Vegas',
    stateValue: 'NV',
    zipValue: '11111',
    countryValue: 'US'
  },
  complainant_employer_phone: '123-123-4567',
  complainant_hhs_employee: 'Yes',
  immediate_danger_yn: 'Yes',
  narrative: 'Narrative goes here.',
  communication_contact: 'Management',
  communication_contact_other: '',
  witness_first_name_0: 'Adam',
  witness_middle_name_0: 'E',
  witness_last_name_0: 'Smith',
  witness_suffix_0: 'JR',
  witness_alias_nickname_0: 'Ima Goodguy',
  witness_dob_0: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1998'
  },
  witness_email_0: 'b@b.com',
  witness_home_phone_0: '123-123-1234',
  witness_cell_phone_0: '234-234-2345',
  witness_address_0: {
    line1Value: '123 My Street',
    line2Value: 'Apt 507',
    cityValue: 'Mytown',
    stateValue: 'VA',
    zipValue: '22222',
    countryValue: 'US'
  },
  witness_employer_0: 'Acme, Inc.',
  witness_job_title_0: 'Financial Analyst',
  witness_employer_address_0: {
    line1Value: '123 My Way',
    line2Value: 'Suite 500',
    cityValue: 'Menlo Park',
    stateValue: 'CA',
    zipValue: '91222',
    countryValue: 'US'
  },
  witness_work_email_0: 'asmith@acme.com',
  witness_employer_phone_0: '121-232-3443',
  witness_work_phone_0: '232-343-4554',
  victim_first_name: 'Robert',
  victim_middle_name: 'E',
  victim_last_name: 'Wilcox',
  victim_suffix: 'JR',
  victim_alias_nickname: 'Bob',
  victim_address: {
    line1Value: '232 Cherry Tree Ln',
    line2Value: '',
    cityValue: 'Springfield',
    stateValue: 'VA',
    zipValue: '22333',
    countryValue: 'US'
  },
  victim_dob: {
    dayValue: '02',
    monthValue: '01',
    yearValue: '1978'
  },
  victim_ssn: '223-23-2233',
  victim_medicare_number: 'ABCD-343-2334',
  victim_medicaid_number: '01a5fg02hj993gy',
  victim_email: 'b@b.com',
  victim_personal_phone: '234-234-2334',
  victim_alternative_phone: '345-345-3445'
}
